
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'EventExtensionSummary',
})
export default class EventExtensionSummary extends NodeFormMixin {}
